<ion-title>
  <aaa-text display="inline" size="headline" weight="bold" color="dark">
    <ng-content></ng-content>
  </aaa-text>
</ion-title>
